module.exports = __webpack_public_path__ + "static/media/5.a65701ef.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/male/pants/5.png
// module id = 1433
// module chunks = 0